import type { Seal_Motor_Oil } from "gql/api";
import type { EquipmentTableColumn } from "@/composables/equipment/equipmentTypes";

export const sealMotorOilsTableColumns: EquipmentTableColumn<Seal_Motor_Oil>[] =
  [
    {
      editable: true,
      field: "include_koc_timestamp",
      header: "Include KOC",
      sortable: true,
      isCheckbox: true,
      adminOnly: true
    },
    {
      editable: true,
      field: "only_koc_timestamp",
      header: "KOC Only",
      sortable: true,
      isCheckbox: true,
      adminOnly: true
    },
    {
      editable: true,
      field: "include_ecopetrol_timestamp",
      header: "Include Ecopetrol",
      sortable: true,
      isCheckbox: true,
      adminOnly: true
    },
    {
      editable: true,
      field: "only_ecopetrol_timestamp",
      header: "Ecopetrol Only",
      sortable: true,
      isCheckbox: true,
      adminOnly: true
    },
    {
      editable: true,
      field: "name",
      header: "Name",
      sortable: true,
      searchable: true
    },
    {
      editable: true,
      field: "thermal_expansion_factor",
      header: "Thermal Expansion Factor",
      isNumber: true,
      sortable: true,
      adminOnly: true,
      decimalPlaces: 6
    },
    {
      editable: true,
      field: "max_temp_fahrenheit",
      header: "Max Temp (F)",
      isNumber: true,
      sortable: true
    },
    {
      editable: true,
      field: "mf_test_temp1_celsius",
      header: "MF Test Temp 1 (C)",
      adminOnly: true,
      isNumber: true,
      sortable: true
    },
    {
      editable: true,
      field: "mf_test_temp2_celsius",
      header: "MF Test Temp 2 (C)",
      adminOnly: true,
      isNumber: true,
      sortable: true
    },
    {
      editable: true,
      field: "viscosity_test1_centistroke",
      header: "Viscosity Test 1 (cSt)",
      adminOnly: true,
      isNumber: true,
      sortable: true
    },
    {
      editable: true,
      field: "viscosity_test2_centistroke",
      header: "Viscosity Test 2 (cSt)",
      adminOnly: true,
      isNumber: true,
      sortable: true
    },
    {
      editable: true,
      field: "specific_gravity",
      header: "Specific Gravity",
      adminOnly: true,
      isNumber: true,
      sortable: true,
      decimalPlaces: 4
    }
  ];
